import { produce } from "immer";
import {
  FETCH_NETWORK,
  FETCH_NETWORK_SUCCESS,
  FETCH_NETWORK_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_NETWORK,
  ADD_NETWORK_SUCCESS,
  ADD_NETWORK_FAILURE,
  //
  EDIT_NETWORK,
  EDIT_NETWORK_SUCCESS,
  EDIT_NETWORK_FAILURE,
  //
  DELETE_NETWORK,
  DELETE_NETWORK_SUCCESS,
  DELETE_NETWORK_FAILURE,
  //
  SEARCH_NETWORK,
  SEARCH_NETWORK_SUCCESS,
  SEARCH_NETWORK_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingNetwork: false,
  networkList: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentNetwork: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  searchList: [],
};

const NetworkReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_NETWORK:
        draft.isFetchingNetwork = true;
        draft.networkList = [];
        break;
      case FETCH_NETWORK_SUCCESS:
        draft.isFetchingNetwork = false;
        draft.networkList = action.payload;
        break;
      case FETCH_NETWORK_FAILURE:
        draft.networkList = [];
        draft.isFetchingNetwork = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentNetwork = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentNetwork = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_NETWORK:
        draft.isSubmitting = true;
        break;
      case ADD_NETWORK_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_NETWORK_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_NETWORK:
        draft.isSubmitting = true;
        break;
      case EDIT_NETWORK_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_NETWORK_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_NETWORK:
        draft.isDeleting = true;
        break;
      case DELETE_NETWORK_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_NETWORK_FAILURE:
        draft.isDeleting = false;
        break;

      case SEARCH_NETWORK:
        draft.isSearching = true;
        draft.searchList = [];
        break;
      case SEARCH_NETWORK_SUCCESS:
        draft.isSearching = false;
        draft.searchList = action.payload;
        break;
      case SEARCH_NETWORK_FAILURE:
        draft.isSearching = false;
        draft.searchList = [];
        break;

      default:
        return state;
    }
  });

export default NetworkReducer;
